"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2127],{

/***/ 42127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ checkDiffEditCharacterForm; },
/* harmony export */   "Ax": function() { return /* binding */ parseStartMessages; },
/* harmony export */   "Hs": function() { return /* binding */ ChatTypes; },
/* harmony export */   "IN": function() { return /* binding */ getProgressStepValue; },
/* harmony export */   "J6": function() { return /* binding */ parseEditorChats; },
/* harmony export */   "OQ": function() { return /* binding */ formatNumberMillion; },
/* harmony export */   "_1": function() { return /* binding */ formatNumberWithUnit; },
/* harmony export */   "cJ": function() { return /* binding */ getChatRoomLastMessageContent; },
/* harmony export */   "eJ": function() { return /* binding */ getDraft; },
/* harmony export */   "j1": function() { return /* binding */ parsePeekMessage; },
/* harmony export */   "mq": function() { return /* binding */ parseSendMessage; },
/* harmony export */   "vo": function() { return /* binding */ removeEmptyFirstMessageReply; },
/* harmony export */   "yN": function() { return /* binding */ getStoryChatRoomLastMessageContent; }
/* harmony export */ });
/* unused harmony exports MessageTypes, parseChatString, parseUserChatString, getGeneralChat, parseStartText, splitChat, parseChats, getChatProperty, removeSiblingNodesAfterId, hideSiblingNodesAfterId, getLastSenderTag, checkHasEmptyParagraph, removeParagraph, getChatCustomProperty, clearChat, scrollToVpElement, persistContainerScroll, getLastViewableElement, getParsedMessage */
/* harmony import */ var chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36733);
/* harmony import */ var chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8801);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60186);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45874);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var ChatTypes;
(function(ChatTypes) {
    ChatTypes["Sender"] = "sender";
    ChatTypes["Receiver"] = "receiver";
    ChatTypes["Paragraph"] = "paragraph";
    ChatTypes["Narration"] = "narration";
    ChatTypes["Custom"] = "custom";
    ChatTypes["ReceiverImage"] = "receiver_image";
})(ChatTypes || (ChatTypes = {}));
var MessageTypes;
(function(MessageTypes) {
    MessageTypes["Sender"] = "sender";
    MessageTypes["Receiver"] = "receiver";
    MessageTypes["Start"] = "start";
    MessageTypes["Temp"] = "temp";
})(MessageTypes || (MessageTypes = {}));
function splitEditorSentences(text) {
    var regex = /[.?!]\s|\n\n|\n|\s{2,}/g;
    var matches = text.matchAll(regex);
    var indices = Array.from(matches, function(match) {
        return (match === null || match === void 0 ? void 0 : match.index) && match.index + 1 || 0;
    }) || [];
    var parts = [];
    if (indices.length > 0) {
        for(var i = 0; i < indices.length; i++){
            var startIndex = i === 0 ? 0 : indices[i - 1] + 1;
            var endIndex = indices[i];
            var part = text.substring(startIndex, endIndex);
            parts.push({
                content: part.replace(/\\/g, "")
            });
        }
        if (indices.length > 0) {
            var lastPart = text.substring(indices[indices.length - 1] + 1);
            parts.push({
                content: lastPart.replace(/\\/g, "")
            });
        }
    } else {
        parts.push({
            content: text.replace(/\\/g, "")
        });
    }
    return parts;
}
var getInitialProfile = function(name) {
    var id = (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return {
        displayName: name,
        id: id,
        isPov: false,
        name: name,
        profileImage: null
    };
};
var parseEditorChats = function(string, lastId, characters) {
    var isV2Story = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = [];
    var newCharacters = _toConsumableArray(characters);
    var speakerRegex = /\n\n|\n/;
    var hasName = string === null || string === void 0 ? void 0 : string.includes(":");
    var parts = string.split(speakerRegex);
    parts.map(function(part) {
        var curLastId = lastId;
        var content = part.replace(/[\n\n\\]|/g, "").trim();
        var paragraphName = "지문:";
        var name = content.split(":")[0];
        var isParagraph = name === "지문" || !hasName;
        var isNarration = name === "나레이션";
        if (!isParagraph) {
            var name1 = content.split(":")[0];
            var parts = content.split(/(".*?"|[^"]+)(?=\s*")?/g).filter(function(part) {
                return part.trim() !== "";
            });
            parts.map(function(splitedPart) {
                var ref;
                var r = (ref = splitedPart === null || splitedPart === void 0 ? void 0 : splitedPart.replaceAll('"', "")) === null || ref === void 0 ? void 0 : ref.replaceAll("".concat(name1, ":"), "").trim();
                if (r === "") {
                    return;
                }
                var usedCharacter = (newCharacters === null || newCharacters === void 0 ? void 0 : newCharacters.find(function(c) {
                    return c.displayName === name1;
                })) ? true : false;
                var character;
                if (usedCharacter) {
                    character = newCharacters === null || newCharacters === void 0 ? void 0 : newCharacters.find(function(c) {
                        return c.displayName === name1;
                    });
                } else {
                    character = getInitialProfile(name1);
                    if (name1 !== "나레이션") {
                        newCharacters.push(character);
                    }
                }
                var splitedR = splitEditorSentences(r);
                splitedR.map(function(res) {
                    var isProfileShow = false;
                    if ((character === null || character === void 0 ? void 0 : character.id) != curLastId && (character === null || character === void 0 ? void 0 : character.id) !== "0") {
                        isProfileShow = true;
                    }
                    curLastId = character === null || character === void 0 ? void 0 : character.id;
                    var key = (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
                    var position = isV2Story ? isNarration ? undefined : (character === null || character === void 0 ? void 0 : character.position) ? character === null || character === void 0 ? void 0 : character.position : "left" : undefined;
                    if ((character === null || character === void 0 ? void 0 : character.position) && isV2Story) {
                        result.push({
                            object: {
                                text: res.content
                            },
                            objectType: isNarration ? "narration" : "text",
                            id: key,
                            isShowProfile: isProfileShow,
                            characterId: isNarration ? undefined : character === null || character === void 0 ? void 0 : character.id,
                            position: position
                        });
                    } else {
                        result.push({
                            object: {
                                text: res.content
                            },
                            objectType: isNarration ? "narration" : "text",
                            id: key,
                            isShowProfile: isProfileShow,
                            characterId: isNarration ? undefined : character === null || character === void 0 ? void 0 : character.id,
                            position: position
                        });
                    }
                });
            });
        } else {
            var parts1 = content.split(/(".*?"|[^"]+)(?=\s*")?/g).filter(function(part) {
                return part.trim() !== "";
            });
            parts1.map(function(splitedPart) {
                var ref, ref1, ref2, ref3;
                var trimmedResult = (ref3 = (ref2 = (ref1 = (ref = splitedPart === null || splitedPart === void 0 ? void 0 : splitedPart.replaceAll('"', "")) === null || ref === void 0 ? void 0 : ref.replaceAll("".concat(name, ":"), "")) === null || ref1 === void 0 ? void 0 : ref1.replaceAll(paragraphName, "")) === null || ref2 === void 0 ? void 0 : ref2.replaceAll('"', "")) === null || ref3 === void 0 ? void 0 : ref3.replaceAll("*", "").trim();
                if (trimmedResult === "") {
                    return;
                }
                var splitedResult = splitEditorSentences(trimmedResult);
                splitedResult.map(function(res) {
                    var key = (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
                    var isProfileShow = false;
                    curLastId = "";
                    result.push({
                        object: {
                            text: res.content
                        },
                        objectType: "text",
                        id: key,
                        isShowProfile: isProfileShow,
                        characterId: "0"
                    });
                });
            });
        }
    });
    return [
        result,
        newCharacters
    ];
};
function parseSendMessage(content) {
    var regex = /(\*.*?\*)/;
    var splitContent = content.split(regex);
    var arr = [];
    for(var i = 0; i < (splitContent === null || splitContent === void 0 ? void 0 : splitContent.length); i++){
        var item = splitContent[i].replace(/\\/g, "");
        var removed = item.replaceAll("\n", "");
        if (!(removed === null || removed === void 0 ? void 0 : removed.startsWith("*")) && removed) {
            arr.push('"' + removed + '"');
        } else if (removed) {
            arr.push(removed);
        }
    }
    var joinedContent = arr.join("\n");
    return joinedContent;
}
function splitSentences(text, isParagraph) {
    var regex = /[.?!]\s/g;
    var matches = text.matchAll(regex);
    var indices = Array.from(matches, function(match) {
        return (match === null || match === void 0 ? void 0 : match.index) && match.index + 1 || 0;
    }) || [];
    var parts = [];
    if (indices.length > 0) {
        for(var i = 0; i < indices.length; i++){
            var startIndex = i === 0 ? 0 : indices[i - 1] + 1;
            var endIndex = indices[i];
            var part = text.substring(startIndex, endIndex);
            parts.push({
                content: part.replace(/\\/g, ""),
                isParagraph: isParagraph
            });
        }
        if (indices.length > 0) {
            var lastPart = text.substring(indices[indices.length - 1] + 1);
            parts.push({
                content: lastPart.replace(/\\/g, ""),
                isParagraph: isParagraph
            });
        }
    } else {
        parts.push({
            content: text.replace(/\\/g, ""),
            isParagraph: isParagraph
        });
    }
    return parts;
}
var parseChatString = function(string, isAiChat) {
    var result = [];
    var regex = /(\".*?\")|(\*.*?\*)|(?=\n\n)/;
    var arr = string.split(regex);
    arr.filter(function(line) {
        return line && Boolean(line.trim());
    }).map(function(item) {
        var isParagraph = item.startsWith("*");
        var type = isParagraph ? "general" : item.startsWith('"') ? "text" : "general";
        var content = item.replace(/[*"\n\n\\]|/g, "").trim();
        if (!isParagraph && isAiChat) {
            var _result;
            var res = splitSentences(content, isParagraph);
            (_result = result).push.apply(_result, _toConsumableArray(res.map(function(r) {
                return _objectSpreadProps(_objectSpread({}, r), {
                    type: type
                });
            })));
        } else {
            result.push({
                content: content,
                isParagraph: isParagraph,
                type: type
            });
        }
    });
    return result;
};
var parseUserChatString = function(string) {
    var result = [];
    var regex = RegExp("\\*(.*?)\\*", "gs");
    var matches = string.matchAll(regex);
    var lastIndex = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var start = match.index;
            var end = start + match[0].length;
            if (start > lastIndex) {
                var text = string.slice(lastIndex, start).trim();
                if (text) {
                    result.push({
                        content: text,
                        type: "text"
                    });
                }
            }
            var general = match[1].trim();
            if (general) {
                result.push({
                    content: general,
                    type: "general"
                });
            }
            lastIndex = end;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (lastIndex < string.length) {
        var text1 = string.slice(lastIndex).trim();
        if (text1) {
            result.push({
                content: text1,
                type: "text"
            });
        }
    }
    return result.filter(function(item) {
        return item.content !== "";
    });
};
var getGeneralChat = function(id, chat) {
    var GRAY_700 = "#5B5B5B";
    return {
        character: {
            displayName: "General",
            id: "0",
            isPov: false,
            name: "General",
            isOmniscient: true,
            isSender: false
        },
        character_id: "0",
        id: id,
        object: {
            text: chat
        },
        objectType: chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__.ChatItemTypes.Text,
        isProfileShow: false,
        style: {
            bubbleColor: '"rgba(255, 255, 255, 0)"',
            textColor: GRAY_700,
            textAlign: "center",
            textStyle: '"initial"',
            fontWeight: '"bold"',
            wordBreak: "normal"
        }
    };
};
var parseStartMessages = function(item, lastType, type) {
    var ref, ref1;
    var isParagraph = type === ChatTypes.Paragraph;
    var content = (ref1 = (ref = item.replace(/[*"\n\n\\]|/g, "").trim()) === null || ref === void 0 ? void 0 : ref.replace(/[""\n\n\\]|/g, "")) === null || ref1 === void 0 ? void 0 : ref1.trim();
    if (!isParagraph) {
        var isProfileShow = false;
        if (type != lastType && (type === ChatTypes.Sender || type === ChatTypes.Receiver)) {
            isProfileShow = true;
        }
        var key = (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
        return {
            content: content,
            type: type,
            key: key,
            id: key,
            isProfileShow: isProfileShow
        };
    } else {
        var key1 = (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
        var isProfileShow1 = false;
        return {
            content: content,
            type: type,
            key: key1,
            id: key1,
            isProfileShow: isProfileShow1
        };
    }
};
var parseStartText = function(string, id, name) {
    var regex = /(\*.*?\*)|(?=\n\n)/;
    var arr = string.replace(/"/g, "").split(regex);
    var startNarration = {
        id: uuidv4(),
        object: {
            text: "".concat(getJosa(name, "과"), " 이야기를 만들어가세요.")
        },
        objectType: "narration"
    };
    var result = arr.filter(function(line) {
        return line && Boolean(line.trim());
    }).map(function(item, index) {
        var isParagraph = item.startsWith("*");
        var content = item.trim().replace(/[*"\\n]|/g, "");
        return {
            id: index,
            object: {
                text: content
            },
            objectType: "text",
            characterId: isParagraph ? "0" : id
        };
    });
    return [
        startNarration
    ].concat(_toConsumableArray(result));
};
var splitChat = function(string, id) {
    var regex = /(\*.*?\*)|(?=\n\n)/;
    var arr = string.replace(/"/g, "").split(regex);
    var result = arr.filter(function(line) {
        return line && Boolean(line.trim());
    }).map(function(item) {
        var tagId = uuidv4();
        var isParagraph = item.startsWith("*");
        var content = item.trim().replace(/[*"\\n]|/g, "");
        return {
            id: tagId,
            object: {
                text: content
            },
            objectType: "text",
            characterId: isParagraph ? "0" : id,
            style: isParagraph ? INITIAL_GENERAL_BUBBLE_STYLE : null
        };
    });
    return result;
};
function splitPeekSentences(text) {
    var regex = /[.?!]\s|\n\n|\n|\s{2,}/g;
    var matches = text.matchAll(regex);
    var indices = Array.from(matches, function(match) {
        return (match === null || match === void 0 ? void 0 : match.index) && match.index + 1 || 0;
    }) || [];
    var parts = [];
    if (indices.length > 0) {
        for(var i = 0; i < indices.length; i++){
            var startIndex = i === 0 ? 0 : indices[i - 1] + 1;
            var endIndex = indices[i];
            var part = text.substring(startIndex, endIndex);
            parts.push({
                content: part.replace(/\\/g, "")
            });
        }
        if (indices.length > 0) {
            var lastPart = text.substring(indices[indices.length - 1] + 1);
            parts.push({
                content: lastPart.replace(/\\/g, "")
            });
        }
    } else {
        parts.push({
            content: text.replace(/\\/g, "")
        });
    }
    return parts;
}
var parseChats = function(string, lastType) {
    var defaultType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "receiver";
    var ref;
    var result = [];
    var curLastType = lastType;
    var firstRegex = /(\"[^"]*\"|\"|[^"]+)/g;
    var firstArr = (ref = string === null || string === void 0 ? void 0 : string.split(firstRegex)) === null || ref === void 0 ? void 0 : ref.filter(function(a) {
        return a && (a === null || a === void 0 ? void 0 : a.trim()) !== "";
    });
    firstArr.map(function(item) {
        var ref, ref1;
        var isParagraph = !item.startsWith('"');
        var content = (ref1 = (ref = item.replace(/[*"\n\n\\]|/g, "").trim()) === null || ref === void 0 ? void 0 : ref.replace(/[""\n\n\\]|/g, "")) === null || ref1 === void 0 ? void 0 : ref1.trim();
        if (!isParagraph) {
            var _result;
            var res = splitPeekSentences(content);
            (_result = result).push.apply(_result, _toConsumableArray(res.map(function(r) {
                var type = isParagraph ? "paragraph" : defaultType;
                var isProfileShow = false;
                if (type != curLastType && (type === ChatTypes.Sender || type === ChatTypes.Receiver)) {
                    isProfileShow = true;
                }
                curLastType = type;
                var key = (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
                return _objectSpreadProps(_objectSpread({}, r), {
                    type: type,
                    key: key,
                    id: key,
                    isProfileShow: isProfileShow
                });
            })));
        } else {
            var key = (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
            var type = isParagraph ? "paragraph" : defaultType;
            var isProfileShow = false;
            if (type != curLastType && (type === ChatTypes.Sender || type === ChatTypes.Receiver)) {
                isProfileShow = true;
            }
            curLastType = type;
            result.push({
                content: content,
                type: type,
                key: key,
                id: key,
                isProfileShow: isProfileShow
            });
        }
    });
    return result;
};
var parsePeekMessage = function(chatItem, character, profile, userName, backgroundImg) {
    var ref;
    var prevType = "";
    var ref1;
    var initialChapterId = (ref1 = (ref = chatItem[0]) === null || ref === void 0 ? void 0 : ref.chapter_id) !== null && ref1 !== void 0 ? ref1 : null;
    var result = _toConsumableArray(chatItem).reverse().map(function(item) {
        if (item.role === "human") {
            var parsedContent = parseChats(item.content, prevType, _constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.SENDER */ .zi.SENDER);
            var arr = [];
            for(var i = 0; i < (parsedContent === null || parsedContent === void 0 ? void 0 : parsedContent.length); i++){
                var value = parsedContent[i];
                if (value.type === ChatTypes.Sender) {
                    var message = getChatProperty(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.SENDER */ .zi.SENDER, value, profile);
                    message.chapter_id = item === null || item === void 0 ? void 0 : item.chapter_id;
                    arr.push(message);
                    prevType = ChatTypes.Sender;
                } else if (value.type === ChatTypes.Narration) {
                    var message1 = getChatProperty(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.GENERAL */ .zi.GENERAL, value);
                    message1.chapter_id = item === null || item === void 0 ? void 0 : item.chapter_id;
                    arr.push(message1);
                    prevType = ChatTypes.Narration;
                } else if (value.type === ChatTypes.Paragraph) {
                    var message2 = getChatProperty(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.GENERAL */ .zi.GENERAL, value, profile);
                    message2.chapter_id = item === null || item === void 0 ? void 0 : item.chapter_id;
                    arr.push(message2);
                    prevType = ChatTypes.Paragraph;
                }
            }
            return arr;
        } else {
            var parsedContent1 = parseChats(item.content, prevType, _constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.RECEIVER */ .zi.RECEIVER);
            var arr1 = [];
            for(var i1 = 0; i1 < (parsedContent1 === null || parsedContent1 === void 0 ? void 0 : parsedContent1.length); i1++){
                var value1 = parsedContent1[i1];
                if (value1.type === ChatTypes.Receiver) {
                    var message3 = getChatProperty(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.RECEIVER */ .zi.RECEIVER, value1, character);
                    message3.chapter_id = item === null || item === void 0 ? void 0 : item.chapter_id;
                    arr1.push(message3);
                    prevType = ChatTypes.Receiver;
                } else if (value1.type === ChatTypes.Narration) {
                    var message4 = getChatProperty(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.GENERAL */ .zi.GENERAL, value1);
                    message4.chapter_id = item === null || item === void 0 ? void 0 : item.chapter_id;
                    arr1.push(message4);
                    prevType = ChatTypes.Narration;
                } else if (value1.type === ChatTypes.Paragraph) {
                    var message5 = getChatProperty(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.GENERAL */ .zi.GENERAL, value1);
                    message5.chapter_id = item === null || item === void 0 ? void 0 : item.chapter_id;
                    arr1.push(message5);
                    prevType = ChatTypes.Paragraph;
                }
            }
            return arr1;
        }
    }).flat();
    var initialNarration = {
        id: (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
        object: {
            text: "인공지능에 의해 생성되는 것으로 대화의 진실성이나\n정확성이 보장되지 않을 수 있습니다"
        },
        objectType: chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__.ChatItemTypes.Narration,
        isProfileShow: false,
        chapter_id: initialChapterId,
        style: {
            bubbleColor: "#ffffff",
            textColor: "#000000",
            textAlign: "initial",
            textStyle: "initial",
            fontWeight: "normal",
            wordBreak: "normal"
        }
    };
    var startNarration = {
        id: (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
        chapter_id: initialChapterId,
        object: {
            text: userName ? "".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .getJosa */ .AI)(character === null || character === void 0 ? void 0 : character.name, "와"), " ").concat(userName, "님이 플레이에서 나눈 대화를 작품처럼 감상해 보세요!") : "".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .getJosa */ .AI)(character === null || character === void 0 ? void 0 : character.name, "와"), " 채티즈가 플레이에서 나눈 대화를 작품처럼 감상해 보세요!")
        },
        objectType: chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__.ChatItemTypes.Narration,
        isProfileShow: false,
        style: {
            bubbleColor: "#ffffff",
            textColor: "#000000",
            textAlign: "initial",
            textStyle: "initial",
            fontWeight: "normal",
            wordBreak: "normal"
        }
    };
    if (backgroundImg === null || backgroundImg === void 0 ? void 0 : backgroundImg.key) {
        var backgroundEfect = {
            id: (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
            chapter_id: initialChapterId,
            is_show_profile: true,
            object: {
                color: null,
                name: "BACKGROUND_IMAGE_CHANGE",
                options: {
                    color: null,
                    image: backgroundImg
                }
            },
            objectType: chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__.ChatItemTypes.Effect
        };
        return [
            backgroundEfect,
            initialNarration,
            startNarration
        ].concat(_toConsumableArray(result));
    }
    return [
        initialNarration,
        startNarration
    ].concat(_toConsumableArray(result));
};
var getChatProperty = function(type, value, character) {
    var id = value.id;
    if (type === _constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.SENDER */ .zi.SENDER) {
        var ref;
        var ref1, ref2, ref3;
        return {
            character: {
                displayName: (ref1 = character === null || character === void 0 ? void 0 : character.name) !== null && ref1 !== void 0 ? ref1 : "나",
                id: (ref2 = character === null || character === void 0 ? void 0 : character.id.toString()) !== null && ref2 !== void 0 ? ref2 : "me",
                isPov: false,
                name: (ref3 = character === null || character === void 0 ? void 0 : character.name) !== null && ref3 !== void 0 ? ref3 : "나",
                profileImage: (character === null || character === void 0 ? void 0 : (ref = character.profile_image) === null || ref === void 0 ? void 0 : ref.key) ? character === null || character === void 0 ? void 0 : character.profile_image : undefined,
                isOmniscient: false,
                isSender: true
            },
            character_id: character === null || character === void 0 ? void 0 : character.id.toString(),
            id: value.id,
            object: {
                text: value.content
            },
            objectType: chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__.ChatItemTypes.Text,
            isProfileShow: !!(value === null || value === void 0 ? void 0 : value.isProfileShow),
            style: {
                bubbleColor: "#ffffff",
                textColor: "#000000",
                textAlign: "initial",
                textStyle: "initial",
                fontWeight: "normal",
                wordBreak: "normal"
            }
        };
    } else if (type === _constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.GENERAL */ .zi.GENERAL) {
        return getGeneralChat(id, value.content);
    } else if (type === _constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.RECEIVER */ .zi.RECEIVER) {
        var ref4;
        var ref5, ref6, ref7;
        return {
            character: {
                displayName: (ref5 = character === null || character === void 0 ? void 0 : character.name) !== null && ref5 !== void 0 ? ref5 : "나",
                id: (ref6 = (character === null || character === void 0 ? void 0 : character.id.toString()) + "-receiver") !== null && ref6 !== void 0 ? ref6 : "me",
                isPov: false,
                name: (ref7 = character === null || character === void 0 ? void 0 : character.name) !== null && ref7 !== void 0 ? ref7 : "나",
                profileImage: (character === null || character === void 0 ? void 0 : (ref4 = character.profile_image) === null || ref4 === void 0 ? void 0 : ref4.key) ? character === null || character === void 0 ? void 0 : character.profile_image : undefined,
                isOmniscient: false,
                isSender: false
            },
            character_id: (character === null || character === void 0 ? void 0 : character.id.toString()) + "-receiver",
            id: id,
            object: {
                text: value.content
            },
            objectType: chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__.ChatItemTypes.Text,
            isProfileShow: !!(value === null || value === void 0 ? void 0 : value.isProfileShow),
            style: {
                bubbleColor: "#ffffff",
                textColor: "#000000",
                textAlign: "initial",
                textStyle: "initial",
                fontWeight: "normal",
                wordBreak: "normal"
            }
        };
    } else if (type === _constants__WEBPACK_IMPORTED_MODULE_1__/* .CHAT_TYPE.NARRATION */ .zi.NARRATION) {
        return {
            id: id,
            object: {
                text: value.content
            },
            objectType: chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__.ChatItemTypes.Narration,
            isProfileShow: false,
            style: {
                bubbleColor: "#ffffff",
                textColor: "#000000",
                textAlign: "initial",
                textStyle: "initial",
                fontWeight: "normal",
                wordBreak: "normal"
            }
        };
    }
    return {
        character: {
            displayName: "나",
            id: "me",
            isPov: false,
            name: "나",
            profileImage: undefined,
            isOmniscient: false,
            isSender: true
        },
        character_id: character === null || character === void 0 ? void 0 : character.id.toString(),
        id: id,
        object: {
            text: ""
        },
        objectType: chatie_viewer_v2__WEBPACK_IMPORTED_MODULE_0__.ChatItemTypes.Text,
        isProfileShow: false,
        style: {
            bubbleColor: "#ffffff",
            textColor: "#000000",
            textAlign: "initial",
            textStyle: "initial",
            fontWeight: "normal",
            wordBreak: "normal"
        }
    };
};
var getDraft = function(leftCharacter, sender, messages, title) {
    var ref, ref1;
    var ref2, ref3, ref4, ref5;
    return {
        characters: [
            {
                name: "General",
                id: "0",
                displayName: "General"
            },
            {
                displayName: (ref2 = sender === null || sender === void 0 ? void 0 : sender.name) !== null && ref2 !== void 0 ? ref2 : "나",
                id: (ref3 = sender === null || sender === void 0 ? void 0 : sender.id.toString()) !== null && ref3 !== void 0 ? ref3 : "me",
                isPov: false,
                name: (ref4 = sender === null || sender === void 0 ? void 0 : sender.name) !== null && ref4 !== void 0 ? ref4 : "나",
                profileImage: (sender === null || sender === void 0 ? void 0 : (ref = sender.profile_image) === null || ref === void 0 ? void 0 : ref.key) ? sender === null || sender === void 0 ? void 0 : sender.profile_image : undefined
            },
            {
                displayName: leftCharacter === null || leftCharacter === void 0 ? void 0 : leftCharacter.name,
                id: (leftCharacter === null || leftCharacter === void 0 ? void 0 : leftCharacter.id.toString()) + "-receiver",
                isPov: false,
                name: leftCharacter === null || leftCharacter === void 0 ? void 0 : leftCharacter.name,
                profileImage: (leftCharacter === null || leftCharacter === void 0 ? void 0 : (ref1 = leftCharacter.profile_image) === null || ref1 === void 0 ? void 0 : ref1.key) ? leftCharacter === null || leftCharacter === void 0 ? void 0 : leftCharacter.profile_image : undefined
            }, 
        ],
        name: title !== null && title !== void 0 ? title : "",
        created: new Date().getTime(),
        currentSceneIndex: 0,
        version: "1.0",
        viewType: "CHAT",
        scenes: [
            {
                id: (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
                senderIds: (ref5 = [
                    sender === null || sender === void 0 ? void 0 : sender.id.toString()
                ]) !== null && ref5 !== void 0 ? ref5 : [
                    "me"
                ],
                name: "",
                items: messages
            }, 
        ]
    };
};
var removeSiblingNodesAfterId = function(id) {
    var element = document.getElementById(id);
    if (!element || !element.parentNode) return;
    var siblingsToRemove = [];
    var found = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = element.parentNode.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var sibling = _step.value;
            if (found) siblingsToRemove.push(sibling);
            if (sibling === element) found = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    siblingsToRemove.forEach(function(sibling) {
        var ref;
        return (ref = sibling.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(sibling);
    });
};
var hideSiblingNodesAfterId = function(id) {
    var element = document.getElementById(id);
    if (!element || !element.parentNode) return;
    var found = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = element.parentNode.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var sibling = _step.value;
            if (found && _instanceof(sibling, HTMLElement)) {
                sibling.style.display = "none";
            }
            if (sibling === element) found = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var getLastSenderTag = function(id) {
    if (id) {
        return document.getElementById(id);
    }
    var element = document.querySelector(".cv2-viewer__content-wrap");
    var siblingSender = Array.from((element === null || element === void 0 ? void 0 : element.children) || []).reverse().find(function(sibling) {
        return sibling.classList.contains("cv2-chat--sender");
    });
    return siblingSender;
};
var checkInnerText = function(text) {
    if (text.length >= 2) {
        return "**";
    }
    return text.slice(1, -1).trim() === "" ? "**" : text;
};
var checkHasEmptyParagraph = function(text) {
    var regex = /\*((?!\n)[\s]+)?\*/g;
    var matches = text.match(regex);
    if ((matches === null || matches === void 0 ? void 0 : matches.length) === 0) {
        return false;
    }
    return matches && (matches === null || matches === void 0 ? void 0 : matches.length) > 0 && matches.every(function(match) {
        return checkInnerText(match) === "**";
    });
};
var removeParagraph = function(text) {
    var regex = /\*((?!\n)[\s]+)?\*|\n\*((?!\n)[\s]+)?\*/g;
    return text.replace(regex, "");
};
var getChatCustomProperty = function(type, value, color, id) {
    var textColor = color !== null && color !== void 0 ? color : "#5B5B5B";
    return {
        character: {
            displayName: "General",
            id: "0",
            isPov: false,
            name: "General",
            isOmniscient: true,
            isSender: false
        },
        id: id !== null && id !== void 0 ? id : "0",
        object: {
            text: value.content
        },
        objectType: ChatItemTypes.Text,
        isProfileShow: false,
        style: {
            bubbleColor: '"rgba(255, 255, 255, 0)"',
            textColor: textColor,
            textAlign: "center",
            textStyle: '"initial"',
            fontWeight: '"bold"',
            wordBreak: "normal",
            fontFamily: ""
        }
    };
};
var clearChat = function() {
    var parentElement = document.querySelector(".cv2-viewer__content-wrap");
    if (parentElement) {
        var elementsToRemove = Array.from(parentElement.children).filter(function(child) {
            return !child.classList.contains("cv2-push");
        });
        elementsToRemove.forEach(function(element) {
            parentElement.removeChild(element);
        });
    }
};
var scrollToVpElement = function(container, targetElement, height) {
    if (!container || !targetElement) {
        return;
    }
    var screenCenter = window.innerHeight * 0.4;
    var targetTop = targetElement.getBoundingClientRect().top;
    if (targetTop) {
        container.scrollTop += targetTop - screenCenter - height;
    }
};
var persistContainerScroll = function(selector, prevScrollHeight) {
    var updatedContainer = document.querySelector(selector);
    var ref;
    var newHeight = (ref = updatedContainer === null || updatedContainer === void 0 ? void 0 : updatedContainer.scrollHeight) !== null && ref !== void 0 ? ref : 0;
    if (updatedContainer) {
        updatedContainer.scrollTop = newHeight - prevScrollHeight;
    }
};
var getLastViewableElement = function() {
    var viewport = document.querySelector(".cv2-viewer__content");
    if (!viewport) return;
    var viewportTop = viewport.scrollTop;
    var viewportBottom = viewportTop + viewport.clientHeight;
    var parentTag = document.querySelector(".cv2-viewer__content-wrap");
    if (!parentTag) return;
    var children = Array.from(parentTag.children);
    var lastVisibleChild = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            var rect = child.getBoundingClientRect();
            var elementTop = viewportTop + rect.top;
            var elementBottom = elementTop + rect.height;
            if (elementTop >= viewportTop && elementBottom <= viewportBottom - 100) {
                lastVisibleChild = child;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return lastVisibleChild !== null && lastVisibleChild !== void 0 ? lastVisibleChild : null;
};
var getChatRoomLastMessageContent = function(item) {
    var ref, ref1;
    if (!item) {
        return item;
    }
    var regex = /(\".*?\")|(\*.*?\*)|(?=\n\n)/;
    var arr = item.split(regex);
    var filteredArr = arr.filter(function(item) {
        if (item == null) return false;
        if (item.trim().length === 0) return false;
        return true;
    });
    var content = (ref1 = (ref = filteredArr[filteredArr.length - 1]) === null || ref === void 0 ? void 0 : ref.replaceAll('"', "")) === null || ref1 === void 0 ? void 0 : ref1.replaceAll("*", "");
    var reg = /(".*?")|(\*.*?\*)|(\?|\!|\.)|(?=\n\n)/;
    var parsedContent = content.split(reg).filter(function(item) {
        return Boolean(item);
    });
    var finalContent = [];
    for(var i = 0; i < parsedContent.length; i++){
        if ([
            "?",
            "!",
            "."
        ].includes(parsedContent[i]) && finalContent[finalContent.length - 1]) {
            finalContent[finalContent.length - 1] += parsedContent[i];
        } else {
            finalContent.push(parsedContent[i]);
        }
    }
    var result = finalContent[(finalContent === null || finalContent === void 0 ? void 0 : finalContent.length) - 1];
    return (result === null || result === void 0 ? void 0 : result.length) > 22 ? result.slice(0, 20) + "..." : result;
};
var getStoryChatRoomLastMessageContent = function(item) {
    if (!item) {
        return item;
    }
    var speakerRegex = /\n\n|\n/;
    var parts = item.split(speakerRegex);
    if (!(parts === null || parts === void 0 ? void 0 : parts.length)) {
        return getChatRoomLastMessageContent(item);
    }
    var newItem = parts[(parts === null || parts === void 0 ? void 0 : parts.length) - 1];
    var result = "";
    if (newItem === null || newItem === void 0 ? void 0 : newItem.startsWith("*")) {
        var ref;
        result = (ref = newItem === null || newItem === void 0 ? void 0 : newItem.replaceAll('"', "")) === null || ref === void 0 ? void 0 : ref.replaceAll("*", "");
    } else {
        var ref1, ref2;
        var name = newItem.split(":")[0];
        result = name ? (ref2 = (ref1 = newItem.replace("".concat(name, ":"), "")) === null || ref1 === void 0 ? void 0 : ref1.replaceAll('"', "")) === null || ref2 === void 0 ? void 0 : ref2.replaceAll("*", "") : newItem;
    }
    return (result === null || result === void 0 ? void 0 : result.length) > 22 ? result.slice(0, 20) + "..." : result;
};
var formatNumberWithUnit = function(num) {
    if (num >= 10000) {
        return "".concat(Math.floor(num / 10000), "만명 pick \uD83D\uDD25");
    } else if (num >= 1000) {
        return "".concat(Math.floor(num / 1000), "천명 pick \uD83D\uDD25");
    } else if (num >= 100) {
        return "".concat(Math.floor(num / 100), "백명 pick \uD83D\uDD25");
    } else {
        return;
    }
};
var formatNumberMillion = function(num) {
    if (!num || num === 0) {
        return "0";
    }
    if (num < 10000) {
        return (0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .formatComma */ .cO)(num);
    } else if (num < 100000000) {
        var koreanNum = (num / 10000).toFixed(1);
        return koreanNum.replace(".0", "") + "만";
    } else {
        var koreanNum1 = (num / 100000000).toFixed(1);
        return koreanNum1.replace(".0", "") + "억";
    }
};
var getProgressStepValue = function(step) {
    switch(step){
        case 1:
            return {
                icon: "#E5CCFF",
                color: "#F2E5FF",
                text: [
                    "우리 아직 그런 사이 아니잖아..?",
                    "나.. 아직 널 모르겠어",
                    "천천히. 우리에겐 시간이 많으니까", 
                ]
            };
        case 2:
            return {
                icon: "#CC99FF",
                color: "#C9F",
                text: [
                    "이런게 설렘인가? 생각보다 기분 좋네",
                    "너.. 조금 귀여워 보인다?",
                    "오랜만에 느껴보는 설렘이야", 
                ]
            };
        case 3:
            return {
                icon: "#93F",
                color: "#93F",
                text: [
                    "너도 나와 같은 감정일까? 궁금해",
                    "내가 너를 좋아해도 될까..?",
                    "벌써? 좀 더 이따가 가면 안돼?", 
                ]
            };
        case 4:
            return {
                icon: "#60C",
                color: "#D249E8",
                text: [
                    "이런 내 모습 너한테만 보여주는거야",
                    "내 마음이 느껴지니? 이 두근거림",
                    "내가 좋아하는건 너야. 다른건 필요없어 ", 
                ]
            };
        case 5:
            return {
                icon: "#FF07F5",
                color: "linear-gradient(57deg, #FF07F5 19.7%, #ED0064 80.3%)",
                text: [
                    "미치겠다. 네가 너무 좋아져버렸어ㅎ",
                    "오늘 집에 안보낼거야. 그런 줄 알아.",
                    "네가 있어야할 곳은 여기야. 내 옆자리", 
                ]
            };
        default:
            return {
                icon: "\uD83D\uDC9B",
                color: "linear-gradient(57deg, #FF07F5 19.7%, #ED0064 80.3%)",
                text: [
                    "우리 아직 그런 사이 아니잖아..?",
                    "나.. 아직 널 모르겠어",
                    "천천히. 우리에겐 시간이 많으니까", 
                ]
            };
    }
};
var getParsedMessage = function(item) {
    var ref, ref1;
    var prevType = "";
    var id = item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString();
    var origin = item.content;
    var isStart = !!item.is_start_message;
    var type = item.role === "ai" ? MessageTypes.Receiver : MessageTypes.Sender;
    var chats = item.role === "ai" ? parseChats(origin, prevType, MessageTypes.Receiver) : parseChats(origin, prevType, ChatTypes.Sender);
    prevType = (ref1 = chats[(chats === null || chats === void 0 ? void 0 : chats.length) - 1]) === null || ref1 === void 0 ? void 0 : ref1.type;
    return {
        chats: chats,
        type: type,
        id: id !== null && id !== void 0 ? id : "",
        origin: origin,
        isEdited: false,
        isStart: isStart
    };
};
var removeEmptyFirstMessageReply = function(values) {
    var valuesObj = JSON.parse(JSON.stringify(values));
    if (valuesObj.situation_form.start_message_replies.length) {
        valuesObj.situation_form.start_message_replies = valuesObj.situation_form.start_message_replies.filter(function(reply) {
            return reply.content !== "";
        });
    }
    return valuesObj;
};
var checkDiffEditCharacterForm = function(prevData, newData) {
    var prevValue = {
        personality: prevData.character_form.information.personality,
        tone_of_voice: prevData.character_form.information.tone_of_voice,
        characteristics: prevData.character_form.information.characteristics,
        relationship: prevData.profile_form.information.relationship
    };
    return Object.keys(_objectSpread({}, prevValue, newData)).some(function(key) {
        return prevValue[key] !== newData[key];
    });
};


/***/ })

}]);